import Svg, { Circle, Defs, G, Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const StatusRupeeIcon = ({
  width = 100,
  height = 100,
  color1 = '#00B259',
  color2 = '#F7AB20',
  color3 = '#FFD947',
}: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Circle cx={50} cy={50} r={33} fill={color1} opacity={0.2} />
    <Circle cx={50} cy={50} r={24} fill={color1} opacity={0.1} />
    <G filter="url(#a)">
      <Circle cx={50} cy={49.999} r={25.6} fill={color2} />
    </G>
    <G filter="url(#b)">
      <Circle cx={50} cy={50} r={40} fill={color2} />
    </G>
    <G filter="url(#c)">
      <Path
        fill={color3}
        d="M90 50c0 22.091-17.909 40-40 40S10 72.091 10 50s17.909-40 40-40 40 17.909 40 40Zm-75.376 0c0 19.537 15.839 35.376 35.376 35.376S85.376 69.537 85.376 50 69.537 14.624 50 14.624 14.624 30.463 14.624 50Z"
      />
    </G>
    <G filter="url(#d)">
      <Path
        fill={color3}
        d="M50 25.569a24.192 24.192 0 1 0 0 48.384 24.192 24.192 0 0 0 0-48.384Zm9.677 19.353a2.419 2.419 0 1 1 0 4.839h-2.758a9.677 9.677 0 0 1-6.314 6.725l5.467 3.29a2.42 2.42 0 0 1-2.467 4.161l-12.096-7.258s-.145-.145-.218-.193a1.62 1.62 0 0 1-.363-.339l-.266-.363a2.425 2.425 0 0 1-.194-.435 2.874 2.874 0 0 1 0-.484l-.145-.266v-.17a3.12 3.12 0 0 1 0-.459c.042-.158.099-.312.17-.46v-.145c0-.145.145-.145.193-.218.094-.137.208-.26.339-.362.12-.103.249-.192.387-.266l.387-.194h.508l.436-.145h4.838a4.839 4.839 0 0 0 4.16-2.42H40.324a2.42 2.42 0 0 1 0-4.838h11.419a4.838 4.838 0 0 0-4.161-2.419h-7.258a2.42 2.42 0 0 1 0-4.838h19.354a2.419 2.419 0 1 1 0 4.838h-3.774a9.318 9.318 0 0 1 1.016 2.42h2.758Z"
      />
    </G>
    <Defs />
  </Svg>
)
export default StatusRupeeIcon
